import type { FC } from 'react';

import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Button, Spacing, Typography } from 'enable-ui';

import { BorderContainer } from 'modules/dashboard/styles/common';

import { ReactComponent as NextIcon } from 'assets/icons/next.svg';

import type { ClassesCreateCompProps } from '../core/type';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { ClassesForm } from './ClassesForm';

export const ClassesCreateComp: FC<ClassesCreateCompProps> = ({
  searchValue,
  onChangeSearchValue,
  coursesData,
  goToAddPage,
  handleSelectedCourse,
  selectedCourse,
  onDeleteSelectedCourse,
  disabledNextButton,
  name,
  description,
  handleChange,
  file,
  onChangeFiles,
  onDeleteThumbnail,
  isBiologicAdmin,
  institutions,
  institutionId,
  onChangeInstitution,
  handleGetWidthAndHeightThumbnail,
  onChangeSearchInstitution,
  searchSelect,
  stations,
  onChangeStation,
  selectedStation,
}) => {
  const station = stations.find((el) => el.id === selectedStation?.value);

  return (
    <div>
      <ClassesForm
        coursesData={coursesData}
        handleSelectedCourse={handleSelectedCourse}
        onChangeSearchValue={onChangeSearchValue}
        onDeleteSelectedCourse={onDeleteSelectedCourse}
        searchValue={searchValue}
        selectedCourse={selectedCourse}
        name={name}
        description={description}
        handleChange={handleChange}
        file={file}
        handleGetWidthAndHeightThumbnail={handleGetWidthAndHeightThumbnail}
        onChangeFiles={onChangeFiles}
        onDeleteThumbnail={onDeleteThumbnail}
      />

      <BorderContainer className="mt-24">
        <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
          Center and address
        </Typography>

        {isBiologicAdmin && (
          <Spacing className="mt-24 max-w-800">
            <InputTitle title="Institution" />
            <CommonSelect
              isBorderInput
              value={institutions.find((item: any) => item.value === institutionId) ?? null}
              options={institutions.filter((item: any) =>
                item.label.toLowerCase().includes(searchSelect.toLowerCase()),
              )}
              onChange={onChangeInstitution}
              onInputChange={onChangeSearchInstitution}
              noOptionsMessage={() => 'Not Found Institution'}
            />
          </Spacing>
        )}

        <Spacing className="mt-24 max-w-800">
          <InputTitle title="Center" />
          <CommonSelect
            isBorderInput
            value={selectedStation as { value: string; label: string }}
            options={stations.map((el) => ({ value: el.id, label: el.name }))}
            onChange={onChangeStation}
            onInputChange={() => {}}
          />
        </Spacing>

        {station && (
          <Spacing className="mt-24">
            <InputTitle title="Address" />
            <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
              {station?.address ? station?.address + ',' : ''}{' '}
              {station?.city ? station?.city + ',' : ''}{' '}
              {station?.state ? station?.state + ',' : ''}{' '}
              {station?.country ? station?.country : ''}
            </Typography>
          </Spacing>
        )}

        <Spacing
          style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            borderTop: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
            background: COLOR_CONFIG.white,
            marginLeft: '-48px',
            padding: '16px 32px',
          }}
        >
          <Button
            color="primary"
            placementIcon="right"
            icon={<NextIcon />}
            onClick={goToAddPage}
            disabled={disabledNextButton}
          >
            Next
          </Button>
        </Spacing>
      </BorderContainer>
    </div>
  );
};
